// @flow
import type { ClientMonthlyData } from 'client-web-app/reports';
import { isLocalDateInYearMonth } from 'date-functions';

const getCategorizeStatusForDate = (
  date: string,
  clientMonthlyData: Array<ClientMonthlyData>,
): ?string => {
  const monthlyDataForDate = clientMonthlyData.find(monthlyData =>
    isLocalDateInYearMonth(date, monthlyData.month),
  );

  return monthlyDataForDate ? monthlyDataForDate.categorizeStatus : null;
};

export default getCategorizeStatusForDate;
